module.exports = __webpack_public_path__ + "static/media/ExpressJS_Badge.c3dcfc3e.png";